import React from "react"
import ReactDOM from "react-dom"
import { PageLayout } from "rs-page"
import Header from "app/components/common/Header"
import Sidebar from "app/components/common/Sidebar"
import MainContent from "app/components/common/MainContent"
import "./Index.scss"

export default class Layout extends PageLayout {
    // 使用 redux 以后，此处静态方法大部分情况下无需调用
    static init(Component) {
        ReactDOM.render(<Component />, document.getElementById("root"))
    }

    system = {
      name: "PGX CLOUD",
      admin: false
    }

    renderHeader() {
        return <Header system={this.system} />
    }

    renderTopBar() {
       return <Sidebar system={this.system} />
    }

    renderMain() {
        return (
            <MainContent>
                {this.renderContent()}
            </MainContent>
        )
    }

    renderContent() {
        return "请自行覆盖renderContent方法"
    }
}



// WEBPACK FOOTER //
// ./src/app/core/Layout/index.js